module.exports = __webpack_public_path__ + "static/header-bg-521b50451bd0babb0c40669c05203e19.jpg";